export enum LanguagesEnum {
  ZH = 'zh_CN', // Chinese (Simplified)
  CZ = 'cs_CZ', // Czech
  DK = 'da_DK', // Danish
  NL = 'nl_NL', // Dutch
  EN = 'en_GB', // English
  FI = 'fi_FI', // Finnish
  FR = 'fr_FR', // French
  DE = 'de_DE', // German
  KL = 'kl_GL', // Greenlandic
  IT = 'it_IT', // Italian
  LV = 'lv_LV', // Latvian
  LT = 'lt_LT', // Lithuanian
  NO = 'nb_NO', // Norwegian
  PL = 'pl_PL', // Polish
  PG = 'pt_PT', // Portuguese (Portugal)
  BR = 'pt_BR', // Portuguese (Brazil)
  ES = 'es_ES', // Spanish
  SE = 'sv_SE', // Swedish
  TR = 'tr_TR', // Turkish
  VI = 'vi_VN', // Vietnamese
  AR = 'ar_SA', // Arabic
  UA = 'uk_UA', //Ukrainian
  RO = 'ro_RO', // Romanian
  BG = 'bg_BG', // Bulgarian
  EL = 'el_GR', // Greek
  ET = 'et_EE', // Estonian
  HE = 'he_IL', // Hebrew
  HU = 'hu_HU', // Hungarian
  ID = 'id_ID', // Indonesian
  JA = 'ja_JP', // Japanese
  KO = 'ko_KR', // Korean
  RU = 'ru_RU', // Russian
  SK = 'sk_SK', // Slovak
  SL = 'sl_SI', // Slovenian
  TH = 'th_TH', // Thai
  HR = 'hr_HR', // Croatian
  SR = 'sr_RS', // Serbian
  MS = 'ms_MY', // Malay
  HI = 'hi_IN', // Hindi
  SQ = 'sq_AL', // Albanian
  BA = 'bs_BA', // Bosnian
  MK = 'mk_MK', // Macedonian
  IS = 'is_IS', // Icelandic
  LB = 'lb_LU', // Luxembourgish
  TL = 'tl_PH', // Tagalog
  TA = 'ta_IN', // Tamil
  BN = 'bn_IN', // Bengali
  FA = 'fa_IR', // Persian
  UR = 'ur_PK', // Urdu
}

export const languageDisplayLabel: { [key: string]: string } = {
  [LanguagesEnum.ZH]: '中文 [Chinese (Simplified)]',
  [LanguagesEnum.CZ]: 'Čeština [Czech]',
  [LanguagesEnum.DK]: 'Dansk [Danish]',
  [LanguagesEnum.NL]: 'Nederlands [Dutch]',
  [LanguagesEnum.EN]: 'English [English]',
  [LanguagesEnum.FI]: 'Suomi [Finnish]',
  [LanguagesEnum.FR]: 'Français [French]',
  [LanguagesEnum.DE]: 'Deutsch [German]',
  [LanguagesEnum.KL]: 'Kalaallisut [Greenlandic]',
  [LanguagesEnum.IT]: 'Italiano [Italian]',
  [LanguagesEnum.LV]: 'Latviešu [Latvian]',
  [LanguagesEnum.LT]: 'Lietuvių [Lithuanian]',
  [LanguagesEnum.NO]: 'Norsk [Norwegian]',
  [LanguagesEnum.PL]: 'Polski [Polish]',
  [LanguagesEnum.PG]: 'Português [Portuguese (Portugal)]',
  [LanguagesEnum.BR]: 'Português [Portuguese (Brazil)]',
  [LanguagesEnum.ES]: 'Español [Spanish]',
  [LanguagesEnum.SE]: 'Svenska [Swedish]',
  [LanguagesEnum.TR]: 'Türkçe [Turkish]',
  [LanguagesEnum.VI]: 'Tiếng Việt [Vietnamese]',
  [LanguagesEnum.AR]: 'اَلْعَرَبِيَّة [Arabic]',
  [LanguagesEnum.UA]: 'Украї́нська мо́ва [Ukrainian]',
  [LanguagesEnum.RO]: 'Română [Romanian]',
  [LanguagesEnum.BG]: 'Български [Bulgarian]',
  [LanguagesEnum.EL]: 'Ελληνικά [Greek]',
  [LanguagesEnum.ET]: 'Eesti keel [Estonian]',
  [LanguagesEnum.HE]: 'עברית [Hebrew]',
  [LanguagesEnum.HU]: 'Magyar [Hungarian]',
  [LanguagesEnum.ID]: 'Bahasa Indonesia [Indonesian]',
  [LanguagesEnum.JA]: '日本語 [Japanese]',
  [LanguagesEnum.KO]: '한국어 [Korean]',
  [LanguagesEnum.RU]: 'Русский [Russian]',
  [LanguagesEnum.SK]: 'Slovenčina [Slovak]',
  [LanguagesEnum.SL]: 'Slovenščina [Slovenian]',
  [LanguagesEnum.TH]: 'ไทย [Thai]',
  [LanguagesEnum.HR]: 'Hrvatski [Croatian]',
  [LanguagesEnum.SR]: 'Српски [Serbian]',
  [LanguagesEnum.MS]: 'Bahasa Melayu [Malay]',
  [LanguagesEnum.HI]: 'हिन्दी [Hindi]',
  [LanguagesEnum.SQ]: 'Shqip [Albanian]',
  [LanguagesEnum.BA]: 'Bosanski [Bosnian]',
  [LanguagesEnum.MK]: 'Македонски [Macedonian]',
  [LanguagesEnum.IS]: 'Íslenska [Icelandic]',
  [LanguagesEnum.LB]: 'Lëtzebuergesch [Luxembourgish]',
  [LanguagesEnum.TL]: 'Tagalog [Tagalog]',
  [LanguagesEnum.TA]: 'தமிழ் [Tamil]',
  [LanguagesEnum.BN]: 'বাংলা [Bengali]',
  [LanguagesEnum.FA]: 'فارسی [Persian]',
  [LanguagesEnum.UR]: 'اردو [Urdu]',
};

export const languageDisplayCode: { [key: string]: string } = {
  [LanguagesEnum.ZH]: 'ZH', // Chinese (Simplified)
  [LanguagesEnum.CZ]: 'CZ', // Czech
  [LanguagesEnum.DK]: 'DK', // Danish
  [LanguagesEnum.NL]: 'NL', // Dutch
  [LanguagesEnum.EN]: 'EN', // English
  [LanguagesEnum.FI]: 'FI', // Finnish
  [LanguagesEnum.FR]: 'FR', // French
  [LanguagesEnum.DE]: 'DE', // German
  [LanguagesEnum.KL]: 'KL', // Greenlandic
  [LanguagesEnum.IT]: 'IT', // Italian
  [LanguagesEnum.LV]: 'LV', // Latvian
  [LanguagesEnum.LT]: 'LT', // Lithuanian
  [LanguagesEnum.NO]: 'NO', // Norwegian
  [LanguagesEnum.PL]: 'PL', // Polish
  [LanguagesEnum.PG]: 'PG', // Portuguese (Portugal)
  [LanguagesEnum.BR]: 'BR', // Portuguese (Brazil)
  [LanguagesEnum.ES]: 'ES', // Spanish
  [LanguagesEnum.SE]: 'SE', // Swedish
  [LanguagesEnum.TR]: 'TR', // Turkish
  [LanguagesEnum.VI]: 'VI', // Vietnamese
  [LanguagesEnum.AR]: 'AR', // Arabic
  [LanguagesEnum.UA]: 'UA', // Ukrainian
  [LanguagesEnum.RO]: 'RO', // Romanian
  [LanguagesEnum.BG]: 'BG', // Bulgarian
  [LanguagesEnum.EL]: 'EL', // Greek
  [LanguagesEnum.ET]: 'ET', // Estonian
  [LanguagesEnum.HE]: 'HE', // Hebrew
  [LanguagesEnum.HU]: 'HU', // Hungarian
  [LanguagesEnum.ID]: 'ID', // Indonesian
  [LanguagesEnum.JA]: 'JA', // Japanese
  [LanguagesEnum.KO]: 'KO', // Korean
  [LanguagesEnum.RU]: 'RU', // Russian
  [LanguagesEnum.SK]: 'SK', // Slovak
  [LanguagesEnum.SL]: 'SL', // Slovenian
  [LanguagesEnum.TH]: 'TH', // Thai
  [LanguagesEnum.HR]: 'HR', // Croatian
  [LanguagesEnum.SR]: 'SR', // Serbian
  [LanguagesEnum.MS]: 'MS', // Malay
  [LanguagesEnum.HI]: 'HI', // Hindi
  [LanguagesEnum.SQ]: 'SQ', // Albanian
  [LanguagesEnum.BA]: 'BA', // Bosnian
  [LanguagesEnum.MK]: 'MK', // Macedonian
  [LanguagesEnum.IS]: 'IS', // Icelandic
  [LanguagesEnum.LB]: 'LB', // Luxembourgish
  [LanguagesEnum.TL]: 'TL', // Tagalog
  [LanguagesEnum.TA]: 'TA', // Tamil
  [LanguagesEnum.BN]: 'BN', // Bengali
  [LanguagesEnum.FA]: 'FA', // Persian
  [LanguagesEnum.UR]: 'UR', // Urdu
};
